import { t_dataName } from "src/app/services/apiHandler/basicMachineFunctions/basic-machine-functions.service";


export enum e_errorCodes {
    File_Invalid = 1,
    Machine = 2,
    Timeout = 3,
    File_Open = 4,
    Validation = 5
}

  //in_cmd?: number, load_test?: number, out_cmd?: number, out_str?: string, running_test?: number, stop?: boolean
  /** 
   * STATE (out_cmd)
   * PRECONDITION = 0
   * EXECUTION = 1
   * EVALUATION = 2
   * SUCCESS = 3
   * FAILURE = 4
   * PENDING = 5
   * CONFIRMATION BTN = 6
   * 
   * SET (in_cmd)
   * FAILURE = 1
   * SUCCESS = 2
   */ 

export enum e_endOfLine {
    Precondition = 0,
    Execution = 1,
    Evaluation = 2,
    Success = 3,
    Failure = 4,
    Pending = 5,
    Confirmation_Btn = 6,
    Reject_Test = 1,
    Confirm_Test = 2
}

export interface SubItem {
  name: string;
  id: number;
  type?: string;
  imageURL?: string;
  state: string;
  done?: boolean;
  pre?: string[];
  exec?: string[];
  eval?: string[];
  comment?: string;
  lastText?: string;
}

export interface ListItem {
  name: string;
  done: boolean;
  subItems?: SubItem[];
}

export type t_ComissionDataPoint = {
    generalName: string;
    dataName: t_dataName;
    value?: number;
};

export type t_ComissionDataset = {
    dataPoints: t_ComissionDataPoint[];
};

export var initComissionLogDataset: t_ComissionDataset = {
    dataPoints: [
        {
            generalName: 'HashMachineParams',
            dataName: {
                name: 'HashMachineParams',
            }
        },
        {
            generalName: 'HashMachineOptions',
            dataName: {
                name: 'HashMachineOptions',
            }
        },
        {
            generalName: 'EndOfLineTool_RemoveEolFramework',
            dataName: {
                name: 'EndOfLineTool_RemoveEolFramework',
            }
        }
    ]
};

export var initComissionParaDataset: t_ComissionDataset = {
    dataPoints: [
        {
            generalName: 'MachineParamsWriteStart',
            dataName: {
                name: 'MachineParamsWriteStart',
            }
        },
        {
            generalName: 'MachineParamsWriteStatus',
            dataName: {
                name: 'MachineParamsWriteStatus',
            }
        },
    ]
};

export var initComissionOptionsDataset: t_ComissionDataset = {
    dataPoints: [
        {
            generalName: 'MachineOptionsWriteStart',
            dataName: {
                name: 'MachineOptionsWriteStart',
            }
        },
        {
            generalName: 'MachineOptionsWriteStatus',
            dataName: {
                name: 'MachineOptionsWriteStatus',
            }
        },
    ]
};

export var initComissionEOLDataset: t_ComissionDataset = {
    dataPoints: [
        {
            generalName: 'EndOfLineTool_LoadTest',
            dataName: {
                name: 'EndOfLineTool_LoadTest',
            }
        },
        {
            generalName: 'EndOfLineTool_inCommand',
            dataName: {
                name: 'EndOfLineTool_inCommand',
            }
        },
        {
            generalName: 'EndOfLineTool_OutCommand',
            dataName: {
                name: 'EndOfLineTool_OutCommand',
            }
        },
        {
            generalName: 'EndOfLineTool_OutString',
            dataName: {
                name: 'EndOfLineTool_OutString',
            }
        },
        {
            generalName: 'EndOfLineTool_RunningTest',
            dataName: {
                name: 'EndOfLineTool_RunningTest',
            }
        },
        {
            generalName: 'EndOfLineTool_Stop',
            dataName: {
                name: 'EndOfLineTool_Stop',
            }
        },
        {
            generalName: 'EndOfLineTool_TestTreeRead',
            dataName: {
                name: 'EndOfLineTool_TestTreeRead',
            }
        },
        {
            generalName: 'EndOfLineTool_OutCommandString',
            dataName: {
                name: 'EndOfLineTool_OutCommandString',
            }
        },
    ]
};